import { parseISO } from 'date-fns'
import {
  findResourceOfType,
  OpalApiComponent,
  OpalApiResponseDocument,
} from '@opallabs/api'
import type { Plan } from '../types'

type ConnectorComponent = OpalApiComponent<'V3', 'block_connector'>
type BlockResponse = OpalApiResponseDocument<'ReadBlockV3', 200>
type PlansResponse = OpalApiResponseDocument<'ReadPlansBFFV1', 200>

export const selectBlockPlanStatus = (response: BlockResponse) => {
  const blockConnectors = response.data.relationships.block_connectors
  if (!blockConnectors || !blockConnectors.data.length)
    return { isOnPlan: false }
  let nonSupportConnector: ConnectorComponent | undefined = undefined

  // for loop so we can exit early once we find a non-supportive block connection
  for (const connector of blockConnectors.data) {
    const includedConnector = response.included?.find(
      findResourceOfType('block_connector', 'V3', connector.id)
    )

    if (!includedConnector) continue
    // No category data means the block is on a plan but only
    // available in the table
    if (!includedConnector.relationships.category?.data) {
      nonSupportConnector = includedConnector
      break
    }

    const connectedCategory = response.included?.find(
      findResourceOfType(
        'category',
        'V3',
        includedConnector.relationships.category.data.id
      )
    )
    if (connectedCategory?.attributes.is_supportive === false) {
      nonSupportConnector = includedConnector
      break
    }
  }

  if (!nonSupportConnector) return { isOnPlan: false }

  const view = response.included?.find(
    findResourceOfType(
      'view',
      'V3',
      nonSupportConnector.relationships.view.data.id
    )
  )

  return {
    isOnPlan: true,
    planTitle: view?.attributes.title,
  }
}

export const selectPlans = (responseDocument: PlansResponse): Plan[] => {
  return responseDocument.data.map((plan) => ({
    id: plan.id,
    endAt: parseISO(plan.end_at),
    startAt: parseISO(plan.start_at),
    title: plan.title,
    updatedAt: parseISO(plan.updated_at),
    parentBlock: plan.parent_block
      ? {
          id: plan.parent_block.id,
          parentPlan: plan.parent_block.plan
            ? {
                id: plan.parent_block.plan.id,
                title: plan.parent_block.plan.title,
              }
            : undefined,
        }
      : undefined,
  }))
}
